import React, { Component } from 'react';
import { Grid, Button, Dropdown } from 'semantic-ui-react';
import i18n from 'i18next';
import PropTypes from 'prop-types';

export default class SelectListMultiple extends Component {
  static propTypes = {
    filterName: PropTypes.string.isRequired,
    hasSearch: PropTypes.bool,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.arrayOf(
      PropTypes.string.isRequired,
    ),
    disabled: PropTypes.bool,
    renderLabel: PropTypes.func,
  }
  static defaultProps = {
    hasSearch: false,
    headerText: 'Select Options',
    options: [],
    placeholder: 'Select Options',
    value: [],
  }
  static getPropsToState = (props) => {
    const value = props.value || [];
    let options = props.options || [];
    const limit = props.limit || 0;
    if (limit > 0) {
      options = options.map(d => ({
        disabled: limit > 0 && value.length >= limit,
        ...d,
      }));
    }
    // #FIX: add blank space. text & value cannot be same as description value.
    options = options.map((d) => {
      if (d.shortName) {
        return {
          ...d,
          description: ` ${d.shortName}`,
        };
      }
      return {
        ...d,
      };
    });
    return {
      value,
      options,
    };
  }
  constructor(props) {
    super(props);
    const state = SelectListMultiple.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = SelectListMultiple.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, { value }) => {
    this.setState({
      value,
    }, () => {
      this.props.onChange(value, this.props.filterName);
    });
  }
  handleClose = () => {
    this.setState({
      value: [],
    }, () => {
      this.props.onClose(this.props.filterName);
    });
  }
  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={14}>
                  <Dropdown
                    fluid
                    header={this.props.headerText}
                    multiple
                    onChange={this.handleOnChange}
                    options={this.state.options}
                    placeholder={this.props.placeholder}
                    search={this.props.hasSearch}
                    selection
                    renderLabel={this.props.renderLabel}
                    selectOnBlur={false}
                    value={this.state.value}
                    disabled={this.props.disabled}
                    noResultsMessage={i18n.t('No results found', { ns: 'translation' })}
                  />
                </Grid.Column>
                {
                  this.props.value.length > 0 &&
                  <Grid.Column width={2} verticalAlign="middle" className="clearicon">
                    <Button
                      as="a"
                      circular
                      icon="x"
                      onClick={this.handleClose}
                      size="mini"
                      title="Clear"
                    />
                  </Grid.Column>
                }
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/SelectListMultiple.jsx